<script setup lang="ts">
const props = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

const { slice } = toRefs(props)

const products = computed(() => {
  return slice.value.productCollection?.productList?.products ?? []
})
</script>

<template>
  <StrapiSlice
    class="ct-products-collection-feed"
    :slice="slice"
    :index="index"
  >
    <ProductSlider
      v-if="slice?.FeedDisplay?.Display === 'Slider'"
      :products="products"
      :lazy="index > 0"
    />

    <ul
      v-else
      class="ct-products-collection-feed__grid"
    >
      <li
        v-for="(product, i) in products"
        :key="product"
        class="ct-products-collection-feed__grid-item"
      >
        <ProductTile
          :product="product"
          :lazy="index > 0 || i > 2"
        />
      </li>
    </ul>
  </StrapiSlice>
</template>

<style>
@import url("~layers/components/Slices/ProductsCollectionFeed.css");
</style>
